<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 Swanニュース編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトのニュースの編集画面
          form.form-horizontal
            .form-group
              label(for='言語').col-md-12 言語
              .col-md-12
                el-select(v-model='formdata.locale', disabled='', @change='changeLocale')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語') 
                  el-option(value='kr', label='韓国語')
            .form-group(v-if='formdata.entry_id')
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formdata.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formdata.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formdata.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formdata.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formdata.title', placeholder='画面上には表示されません（コンテンツの識別に使います）')
            .form-group
              label.col-md-12 サブタイトル
              .col-md-12
                el-input(type='text', v-model='formdata.subtitle', placeholder='画面上には表示されません（コンテンツの識別に使います）')
            .form-group
              label(for='カテゴリー') カテゴリー
              .col-md-12
                el-select(v-model='formdata.category', placeholder='Select')
                  el-option(value='SWAN本体', label='SWAN本体')
                  el-option(value='スコッチガン', label='スコッチガン') 
                  el-option(value='ワンカップシステム', label='ワンカップシステム')
                  el-option(value='制御盤', label='制御盤')
                  el-option(value='コ・スワン', label='コ・スワン')
                  el-option(value='その他', label='その他')
            .form-group
              label.col-md-12 リードテキスト
              .col-md-12
                el-input(type='textarea', v-model='formdata.lead_text', :rows='5')
            .form-group
              label.col-md-12 本文
              .col-md-12
                el-input(type='textarea', v-model='formdata.body', :rows='5')
            .form-group(v-if='Object.keys(formdata.main_images).length > 0')
              label.col-md-12 メイン画像
              el-table(:data='formdata.main_images')
                el-table-column(label="image", width="300")
                  template(slot-scope="scope")
                    img(:src='scope.row.image_url', height='128')
                el-table-column(property="image_url", label="image_url", width="200")
                el-table-column(label="caption")
                  template(slot-scope="scope")
                    el-input(v-model='scope.row.caption', placeholder='キャプション')
                el-table-column(fixed='right', label='Operations', width='200')
                  template(slot-scope='scope')
                    el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveMainImgUp(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveMainImgDown(scope.$index)')
                    el-button(size='mini', type='danger', icon='el-icon-delete', circle, @click='deleteCommonConfirm(scope.$index, formdata.main_images,scope.row.image_url)')
            .form-group
              label.col-md-12 新規メイン画像
                span(style='margin: 20px')
                  el-button(type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd("btnFileAdd", $event)', v-if='(Object.keys(formdata.main_images).length + Object.keys(formdata.uploadedImages).length) < 5')
              el-table(:data='formdata.uploadedImages')
                el-table-column(label="image", width="300")
                  template(slot-scope="scope")
                    img(:src='scope.row.image', height='128')
                el-table-column(property="name", label="name", width="200")
                el-table-column(label="caption")
                  template(slot-scope="scope")
                    el-input(v-model='scope.row.caption', placeholder='キャプション')
                el-table-column(fixed='right', label='Operations', width='200')
                  template(slot-scope='scope')
                    el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveNewMainImgUp(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveNewMainImgDown(scope.$index)')
                    el-button(size='mini', type='danger', icon='el-icon-delete', circle, @click='deleteCommonConfirm(scope.$index, formdata.uploadedImages,scope.row.name)')
              input#btnFileAdd(type='file', style='visibility: hidden',　@change='onFileAdd(formdata.uploadedImages, $event)')
            .form-group(v-if='Object.keys(formdata.sub_images).length > 0')
              label.col-md-12 サブ画像
              el-table(:data='formdata.sub_images')
                el-table-column(label="image", width="300")
                  template(slot-scope="scope")
                    img(:src='scope.row.image_url', height='128')
                el-table-column(property="image_url", label="image_url", width="200")
                el-table-column(label="caption")
                  template(slot-scope="scope")
                    el-input(v-model='scope.row.caption', placeholder='キャプション')
                el-table-column(fixed='right', label='Operations', width='240')
                  template(slot-scope='scope')
                    el-button(size='mini', type='primary', icon='el-icon-edit', circle, @click='showImgDialog(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-top', circle='true', @click='moveSubImgUp(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle='true', @click='moveSubImgDown(scope.$index)')
                    el-button(size='mini', type='danger', icon='el-icon-delete', circle='true', @click='deleteCommonConfirm(scope.$index, formdata.sub_images,scope.row.image_url)')
            .form-group
              label.col-md-12 新規サブ画像
                span(style='margin: 20px')
                  el-button(type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd("btnSubFileAdd", $event)')
              el-table(:data='formdata.uploadedSubImages')
                el-table-column(label="image", width="300")
                  template(slot-scope="scope")
                    img(:src='scope.row.image', height='128')
                el-table-column(property="name", label="name", width="200")
                el-table-column(label="caption")
                  template(slot-scope="scope")
                    el-input(v-model='scope.row.caption', placeholder='キャプション')
                el-table-column(fixed='right', label='Operations', width='200')
                  template(slot-scope='scope')
                    el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveNewSubImgUp(scope.$index)')
                    el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveNewSubImgDown(scope.$index)')
                    el-button(size='mini', type='danger', icon='el-icon-delete', circle, @click='deleteCommonConfirm(scope.$index, formdata.uploadedSubImages,scope.row.name)')
              input#btnSubFileAdd(type='file', style='visibility: hidden', @change='onFileAdd(formdata.uploadedSubImages, $event)')
            el-dialog(title="サブ画像タグ", :visible.sync='imgDialogVisible')
              .form-group
                label.col-md-12 このimgタグを本文に貼り付けてください。

                .col-md-12
                  el-input(type='textarea', v-model='subImgTag', :rows='5')
            .form-group
              label.col-md-12 発行日
              .col-md-12
                el-date-picker(type='date', value-format='yyyy-MM-dd', v-model='formdata.publish', placeholder='YYYY-MM-DD')
            .form-group
              label.col-md-12 署名
              .col-md-12
                el-input(type='text', v-model='formdata.signature')
  .card
    .col-md-12
      publicSetting(apiname='news', :formdata='formdata')
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import PublicSetting from '@/views/components/swan/common/PublicSetting'

export default {
  name: 'Top',
  data () {
    return {
      imgDialogVisible: false,
      subImgTag: '',
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      formdata: {
        entry_id: '',
        locale: '',
        title: '',
        subtitle: '',
        lead_text: '',
        category: '',
        body: '',
        main_images: [],
        uploadedImages: [],
        sub_images: [],
        uploadedSubImages: [],
        publish: '',
        signature: '',
        open_date: '',
        open_time: '',
        close_date: '',
        close_time: '',
        created_at: '',
        updated_at: '',
        mod_date: '',
        status: '',
        agree_list: [],
        agree_user: '',
        waiting: false
      }
    }
  },
  components: {
    PublicSetting
  },
  created () {
    if (this.$route.query.id) {
      this.getNews(this.$route.query.id, this.$route.query.locale)
    } else {
      this.formdata.locale = 'ja'
    }
    this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
    this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
    this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
    this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
  },
  mounted: function () {
  },
  methods: {
    changeLocale () {
      if (this.formdata.entry_id) {
        this.getNews(this.formdata.entry_id, this.formdata.locale)
      }
    },
    getNews (id, locale) {
      return axios({
        method: 'get',
        url: 'admin/swan/news/edit?entry_id=' + id + '&locale=' + locale,
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        if (Object.keys(res.data).length) {
          var _data = res.data
          this.formdata.locale = _data.locale
          this.formdata.entry_id = _data.entry_id
          this.formdata.title = _data.title
          this.formdata.subtitle = _data.subtitle
          this.formdata.lead_text = _data.lead_text
          this.formdata.body = _data.body
          this.formdata.signature = _data.signature
          this.formdata.category = _data.category
          this.formdata.main_images = _data.main_images
          this.formdata.sub_images = _data.sub_images
          this.formdata.publish = _data.publish
          if (_data.open_at) {
            this.formdata.open_date = moment(_data.open_at).format('YYYY-MM-DD')
            this.formdata.open_time = moment(_data.open_at).format('HH:mm')
          }
          if (_data.close_at) {
            this.formdata.close_date = moment(_data.close_at).format('YYYY-MM-DD')
            this.formdata.close_time = moment(_data.close_at).format('HH:mm')
          }
          this.formdata.created_at = moment(_data.created_at).format('YYYY-MM-DD HH:mm:ss')
          this.formdata.updated_at = moment(_data.updated_at).format('YYYY-MM-DD HH:mm:ss')
          this.formdata.status = _data.status
          this.formdata.staff_list = _data.staff_list
          this.formdata.agree_list = _data.agree_list
          this.formdata.waiting = _data.waiting
        } else {
          this.formdata.entry_id = id
          this.formdata.locale = locale
        }
      }).catch(function (error) {
        this.$message({
          type: 'error',
          message: error
        })
        console.log(error)
      })
    },
    deleteCommonConfirm (index, images, imageName) {
      this.$confirm(imageName + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        images.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onBtnFileAdd (bntId, e) {
      document.getElementById(bntId).click()
    },
    onFileAdd (images, e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          images.push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        this.$message({
          type: 'info',
          message: '画像ではありません'
        })
      }
    },
    moveMainImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.main_images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.main_images[orgIndex])
        this.formdata.main_images = tmp
      }
    },
    moveMainImgDown (orgIndex) {
      if (orgIndex < this.formdata.main_images.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.main_images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.main_images[orgIndex])
        this.formdata.main_images = tmp
      }
    },
    moveNewMainImgDown (orgIndex) {
      if (orgIndex < this.formdata.uploadedImages.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedImages[orgIndex])
        this.formdata.uploadedImages = tmp
      }
    },
    moveNewMainImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedImages[orgIndex])
        this.formdata.uploadedImages = tmp
      }
    },
    moveSubImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.sub_images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.sub_images[orgIndex])
        this.formdata.sub_images = tmp
      }
    },
    moveSubImgDown (orgIndex) {
      if (orgIndex < this.formdata.sub_images.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.sub_images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.sub_images[orgIndex])
        this.formdata.sub_images = tmp
      }
    },
    moveNewSubImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.uploadedSubImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedSubImages[orgIndex])
        this.formdata.uploadedSubImages = tmp
      }
    },
    moveNewSubImgDown (orgIndex) {
      if (orgIndex < this.formdata.uploadedSubImages.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.uploadedSubImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedSubImages[orgIndex])
        this.formdata.uploadedSubImages = tmp
      }
    },
    showImgDialog (index) {
      this.subImgTag = '<img src="' + this.formdata.sub_images[index]['image_url'] + '" border="0" alt="' + this.formdata.sub_images[index]['caption'] + '" />'
      console.log(this.subImgTag)
      this.imgDialogVisible = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/news/edit.vue